import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
    selector: 'app-main-game-finished',
    templateUrl: './main-game-finished.component.html',
    styleUrls: ['./main-game-finished.component.scss'],
    standalone: false
})
export class MainGameFinishedComponent implements OnInit {
  finishedTitle: string = ''
  finishedText: string = ""
  showFinishedButton: boolean = true;

  @Input('gameScreen') gameScreen: string = '';
  @Input('module') module: number = 0;
  @Output() afterDistractionEnd = new EventEmitter<{}>();

  constructor() { }

  ngOnInit() { 
    if (this.gameScreen === 'finishing') {
      this.finishedTitle = 'Please wait...';
      if (this.module === 1) {
        this.finishedText = 'Your results are being saved';
      } 
      else {
        this.finishedText = 'Your results are being calculated';
      }      
      this.showFinishedButton = false;
    }
    else {
      this.finishedTitle = 'Now to the second part of the module'
      this.finishedText = ""
      this.showFinishedButton = true;    
    }
  }

  onAfterDistractionEnd() {
  	this.afterDistractionEnd.emit({});
  }

}
